module.exports = fox._r("images/press/press-social.jpg", __webpack_public_path__ + "_/common/images/press/press-social.jpg");


//////////////////
// WEBPACK FOOTER
// ../common/images/press/press-social.jpg
// module id = 383
// module chunks = 2